const AppConfig = {
  api: {
    url: 'http://localhost:3008/'
  },
  auth: {
    isLoggedIn: 'loggedInLaosHD',
    accessToken: 'accessTokenLaosHD',
    userRole: 'userRole',
  }
}

export default AppConfig;
